import {
    DesignSystemBorderRadius,
    DesignSystemChipRadius,
    DesignSystemChipSize,
    DesignSystemIconSizing,
    DesignSystemTypographyVariants,
} from '@upheal/design-system/theme/design-system/types';

// TODO: create base type SizeOutput, and then extend it for Button and Chip?
type ChipSizeOutput = {
    height: string;
    gap: number;
    paddingX: string | number;
    paddingY: string | number;
    iconPadding: string | number; // padding for icon only
    typographyVariant: DesignSystemTypographyVariants;
    iconSize: DesignSystemIconSizing;
};

export const chipSizeValues: Record<DesignSystemChipSize, ChipSizeOutput> = {
    xxs: {
        height: '16px',
        paddingX: 1,
        paddingY: 0.25,
        iconPadding: 0.5,
        gap: 0.5,
        typographyVariant: 'xxs',
        iconSize: 'xxs',
    },
    xs: {
        height: '20px',
        paddingX: 1,
        paddingY: 0.25,
        iconPadding: 0.5,
        gap: 0.5,
        typographyVariant: 'xs',
        iconSize: 'xs',
    },
    sm: {
        height: '24px',
        paddingX: 1.25,
        paddingY: 0.25,
        iconPadding: 0.75,
        gap: 0.75,
        typographyVariant: 'sm',
        iconSize: 'xs',
    },
    md: {
        height: '28px',
        paddingX: 1.5,
        paddingY: 0.25,
        iconPadding: 0.75,
        gap: 1,
        typographyVariant: 'md',
        iconSize: 'sm',
    },
};

export const getSizeStyles = (
    size: DesignSystemChipSize,
    iconOnly: boolean,
    hasLeadingItem: boolean,
    hasTrailingItem: boolean,
) => {
    const sizeDef = chipSizeValues[size];
    const reduction = 0.25; // MUI spacing = 2px, reduces padding if leading/trailing icon is present

    const paddingX = iconOnly ? sizeDef.iconPadding : sizeDef.paddingX;
    let paddingLeft = paddingX;
    let paddingRight = paddingX;

    if (hasLeadingItem) paddingLeft = Number(paddingLeft) - reduction;
    if (hasTrailingItem) paddingRight = Number(paddingRight) - reduction;

    return {
        height: sizeDef.height,
        minWidth: sizeDef.height,
        width: 'fit-content',
        gap: sizeDef.gap,
        paddingY: iconOnly ? sizeDef.iconPadding : sizeDef.paddingY,
        paddingLeft,
        paddingRight,
    };
};

export const chipRadiusValues: Record<
    DesignSystemChipSize,
    Record<DesignSystemChipRadius, DesignSystemBorderRadius>
> = {
    xxs: {
        full: 'full',
        rounded: 'xs',
    },
    xs: {
        full: 'full',
        rounded: 'xs',
    },
    sm: {
        full: 'full',
        rounded: 'xs',
    },
    md: {
        full: 'full',
        rounded: 'xs',
    },
};
